module.exports = __webpack_public_path__ + "img/xxnl-logo.f4f6a397.png";